<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        style="width: 150px;"
        class="filter-item"
        placeholder="ID"
        v-model="listQuery.number"
      ></el-input>
      <el-input
        style="width: 150px;"
        class="filter-item"
        placeholder="视频交互名称"
        v-model="listQuery.name"
      ></el-input>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
      <el-button
        class="filter-item"
        @click="$refs.edit.handleCreate()"
        type="primary"
        v-permission="['app.add_interactive']"
      >创建视频交互</el-button>
    </div>
    <el-table
      :data="list"
      v-loading.body="listLoading"
      element-loading-text="加载中 ..."
      border
      highlight-current-row>
      <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
      <el-table-column label="ID" width="120" align="center" prop="number"></el-table-column>
      <el-table-column label="视频交互名称" width="180" align="center" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="交互数量" width="200" align="center" prop="count"></el-table-column>
      <el-table-column label="展示/隐藏" width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.is_enable"
            :active-value="true"
            :inactive-value="false"
            @change="handleEnable(scope.row.id, $event)"
            v-if="checkPermission(['base_services.change_miniprogram'])"
          ></el-switch>
          <span v-else>{{scope.row.is_enable ? '启用' : '禁用'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" width="200" align="center" prop="creator"></el-table-column>
      <el-table-column
        label="操作"
        min-width="150px"
        v-if="checkPermission(['base_services.change_miniprogram', 'base_services.delete_miniprogram'])">
        <template slot-scope="scope">
          <el-button
            @click="$refs.edit.handleEdit(scope.row.id, true)"
            v-permission="['app.view_interactive']"
          >查看</el-button>
          <el-button
            @click="$refs.edit.handleEdit(scope.row.id, false)"
            v-if="scope.row.is_enable === false"
            v-permission="['app.change_interactive']"
          >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
    <edit ref="edit"></edit>
  </div>
</template>

<script>
import { getList, toggle } from "@/api/videoAction";
import Edit from "./components/Edit";
import checkPermission from "@/utils/permission";

export default {
  name: "videoActionIndex",
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        name: "",
        number: "",
      },
    };
  },
  components: {
    Edit
  },
  created() {
    this.fetchData();
  },
  methods: {
    checkPermission,
    // 获取数据
    fetchData() {
      this.listLoading = true;
      getList(this.listQuery).then(res => {
        this.list = res.data.results;
        this.count = res.data.count;
        this.listLoading = false;
      });
    },
    // 筛选
    handleFilter() {
      this.listQuery.page = 1;
      this.fetchData();
    },
    // 启用、禁用
    handleEnable(uuid, value) {
      toggle(uuid, {
        is_enable: value
      }).catch(() => {
        this.fetchData();
      });
    },
    // 删除
    // handleDel(uuid) {
    //   this.$confirm("确认删除该项目吗？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   })
    //     .then(() => {
    //       del(uuid).then(() => {
    //         this.$notify({
    //           title: "成功",
    //           message: "删除成功",
    //           type: "success"
    //         });
    //         this.fetchData();
    //       });
    //     })
    //     .catch(() => {});
    // }
  }
};
</script>
